var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferralSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EBF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18524_108451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9292 58.1029L20.9571 39.2112C20.7055 38.8448 20.6675 38.4581 20.8429 38.0512C21.0184 37.6443 21.3251 37.3916 21.7629 37.2932L50.6207 31.3269C51.1587 31.227 51.5849 31.4061 51.8994 31.8641C52.2138 32.3221 52.2279 32.7842 51.9415 33.2504L36.0086 58.0398C35.7595 58.413 35.4135 58.6084 34.9707 58.6261C34.5279 58.6437 34.1808 58.4693 33.9292 58.1029ZM34.858 55.0391L48.1897 34.4113L24.0794 39.3417L28.0417 45.1123L37.8164 41.5342L30.9192 49.3028L34.858 55.0391ZM29.5041 47.2419L24.0794 39.3417L34.858 55.0391L29.5041 47.2419Z",
    fill: "#0056CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18524_108451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 35) rotate(-34.4756)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralSend);
export default __webpack_public_path__ + "static/media/referral-send.f9e89e5a.svg";
export { ForwardRef as ReactComponent };